import { useDispatch as reactReduxUseDispatch, useSelector as reactReduxUseSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { createSelector } from 'reselect';

import { Action } from './actions';
import { SearchDocumentType, SearchSortOrder } from './graphql/gen/types';
import { State } from './models';

export function useDispatch(): Dispatch<Action> {
  return reactReduxUseDispatch<Dispatch<Action>>();
}

export function useSelector<TSelected = unknown>(
  selector: (state: State) => TSelected,
  equalityFn?: (left: TSelected, right: TSelected) => boolean
): TSelected {
  return reactReduxUseSelector<State, TSelected>(selector, equalityFn);
}

export function useSearchText(): string {
  return useSelector(
    createSelector(
      (state: State) => state.search,
      (search) => {
        return search?.input || '';
      }
    )
  );
}

export function useSearchFilters(): SearchDocumentType[] {
  return useSelector(
    createSelector(
      (state: State) => state.search,
      (search) => {
        return search.filters;
      }
    )
  );
}

export function useSearchSortOrder(): SearchSortOrder {
  return useSelector(
    createSelector(
      (state: State) => state.search,
      (search) => {
        return search.sortOrder;
      }
    )
  );
}
